<template>
  <div>
    <h2 class="mb-2 text-20 font-medium">Your order is processing</h2>
    <p>
      Your order is currently being processed.<br />
      We'll send you an email once it's ready.
    </p>
  </div>
</template>
